package external.select

fun filterOptionFun (input:String,option: dynamic):Boolean{
    return option.children?.indexOf(input)?:-1>=0
}
